<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <div class="hloader">
    <img src="../../../assets/images//datax/hloader.gif" style="width: 100%;">
  </div>
</div>